<div class="modal-header po-modal font-weight-bold d-block">
  <button class="close" aria-label="Close" (click)="activeModal.close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ngx-login *ngIf="!isResetPassword && !isForgotPassword"></ngx-login>
  <ngx-forgot-password *ngIf="isForgotPassword"></ngx-forgot-password>
  <ngx-reset-password *ngIf="isResetPassword"></ngx-reset-password>
</div>
